import React, {FC, PropsWithChildren} from 'react';

import {Dialog, DialogProps} from './dialog';
import {DialogContent} from './dialogContent';
import {DialogHeader, DialogHeaderProps} from './dialogHeader';

/*
 * Props.
 */

interface BasicDialogProps extends DialogProps, DialogHeaderProps {}

/*
 * Component.
 */

/** Customizable dialog with a header. */
export const BasicDialog: FC<PropsWithChildren<BasicDialogProps>> = (props) => (
  <Dialog {...props}>
    <DialogHeader {...props} />
    <DialogContent>{props.children}</DialogContent>
  </Dialog>
);
